export const PERFORM_INIT = 'PERFORM_INIT'
export const SET_CURRENT_SESSIONS = 'SET_CURRENT_SESSIONS'
export const SET_CURRENT_GROUP = 'SET_CURRENT_GROUP'
export const SET_CURRENT_ACTOR = 'SET_CURRENT_ACTOR'
export const SET_CURRENT_PRICE_LIST = 'SET_CURRENT_PRICE_LIST'
export const SET_CURRENT_PRICE = 'SET_CURRENT_PRICE'



// WEBPACK FOOTER //
// ./src/store/theatreabove/mutation-types.js